// import { TranslatorManager } from '@managers/TranslatorManager';
import React from 'react';
import { NavigationManager } from 'src/_shared/managers/navigation.manager';
import { QueueManager } from 'src/_shared/managers/queue.manager';
import { TranslatorManager } from 'src/_shared/managers/TranslatorManager';
// import { useStoreSelector } from '@store/hook';
// import { NavigationManager } from '@managers/navigation.manager';
// import { QueueManager } from '@managers/queue.manager';

export const CalendarView: React.FC = () => {
    const translator = TranslatorManager.getInstance();
    const navigationManager = NavigationManager.getInstance();
    const queueManager = QueueManager.getInstance();

    return (
        <>
            <div className='container-fluid'>
                Calendar view
            </div>
        </>
    );
};
